interface StatusBadgeProps {
  status: string;
}

/**
 * Reusable status badge component with consistent styling
 * Uses consolidated .bg-state-{STATUS} and .text-state CSS classes
 */
export function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <div className={`bg-state-${status} rounded-xl px-3 py-1 inline-flex items-center justify-center min-w-28`}>
      <span className={`text-state font-medium text-sm`}>{status}</span>
    </div>
  );
}
